import { Building2 } from "lucide-react";
import { useClientCompanies, ClientCompany } from "@crm/api";

export function ClientsListPage() {
  const { data, isLoading, error } = useClientCompanies();
  const clients = data?.results || [];

  return (
    <div className="p-8">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-foreground">Clients</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Manage client companies and contacts
        </p>
      </div>

      {/* Content */}
      {isLoading ? (
        <div className="flex h-64 items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        </div>
      ) : error ? (
        <div className="rounded-lg border border-destructive bg-destructive/10 p-8 text-center">
          <p className="text-destructive">Failed to load clients</p>
        </div>
      ) : !clients.length ? (
        <div className="rounded-lg border border-border bg-card p-8 text-center">
          <Building2 className="mx-auto h-12 w-12 text-muted-foreground" />
          <p className="mt-4 text-muted-foreground">
            No clients yet. Clients will appear here once added.
          </p>
        </div>
      ) : (
        <div className="rounded-lg border border-border bg-card">
          <table className="w-full">
            <thead>
              <tr className="border-b border-border text-left text-sm font-medium text-muted-foreground">
                <th className="p-4">Company Name</th>
                <th className="p-4">Contacts</th>
                <th className="p-4">Email</th>
              </tr>
            </thead>
            <tbody>
              {clients.map((client: ClientCompany) => (
                <tr
                  key={client.id}
                  className="border-b border-border last:border-0 hover:bg-muted/50"
                >
                  <td className="p-4 font-medium text-foreground">
                    {client.name}
                  </td>
                  <td className="p-4 text-muted-foreground">
                    {client.contact_count || 0}
                  </td>
                  <td className="p-4 text-muted-foreground">
                    {client.email && (
                      <span className="text-sm">{client.email}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
